import React, { useState } from 'react';
import { FiX, FiCalendar } from 'react-icons/fi';

export interface LogsFilterData {
  startDate: string;
  endDate: string;
  status: string;
  analyst: string;
}

interface LogsFilterModalProps {
  isOpen: boolean;
  onClose: () => void;
  onApply: (filters: LogsFilterData) => void;
}

export const LogsFilterModal: React.FC<LogsFilterModalProps> = ({
  isOpen,
  onClose,
  onApply,
}) => {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [status, setStatus] = useState('');
  const [analyst, setAnalyst] = useState('');

  if (!isOpen) return null;

  const handleApply = () => {
    onApply({
      startDate,
      endDate,
      status,
      analyst,
    });
  };

  const handleClear = () => {
    setStartDate('');
    setEndDate('');
    setStatus('');
    setAnalyst('');
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg w-full max-w-lg p-6">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-bold text-neutral-800">Filtros</h2>
          <button
            type="button"
            onClick={onClose}
            className="p-1 text-neutral-500 hover:text-neutral-700 transition-colors"
          >
            <FiX className="w-5 h-5" />
          </button>
        </div>

        {/* Form */}
        <div className="space-y-4 mb-6">
          {/* Date Range */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm text-neutral-700 mb-2">Data inicial</label>
              <div className="relative">
                <input
                  type="text"
                  placeholder="Inserir"
                  value={startDate}
                  onChange={(e) => { setStartDate(e.target.value); }}
                  className="w-full px-3 py-2 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm pr-10"
                />
                <FiCalendar className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-purple-600" />
              </div>
            </div>
            <div>
              <label className="block text-sm text-neutral-700 mb-2">Data final</label>
              <div className="relative">
                <input
                  type="text"
                  placeholder="Inserir"
                  value={endDate}
                  onChange={(e) => { setEndDate(e.target.value); }}
                  className="w-full px-3 py-2 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm pr-10"
                />
                <FiCalendar className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-purple-600" />
              </div>
            </div>
          </div>

          {/* Status and Analyst */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm text-neutral-700 mb-2">Status</label>
              <select
                value={status}
                onChange={(e) => { setStatus(e.target.value); }}
                className="w-full px-3 py-2 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm appearance-none bg-white"
              >
                <option value="">Todos</option>
                <option value="aprovado">Aprovado</option>
                <option value="reprovado">Reprovado</option>
                <option value="recusou">Recusou</option>
              </select>
            </div>
            <div>
              <label className="block text-sm text-neutral-700 mb-2">Analista</label>
              <select
                value={analyst}
                onChange={(e) => { setAnalyst(e.target.value); }}
                className="w-full px-3 py-2 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm appearance-none bg-white"
              >
                <option value="">Todos</option>
                <option value="carlos">Carlos Rodrigues</option>
                <option value="flavia">Flavia Siqueira</option>
                <option value="camila">Camila Oliveira</option>
              </select>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-between">
          <button
            type="button"
            onClick={handleClear}
            className="text-sm text-purple-600 hover:text-purple-700 font-medium transition-colors"
          >
            Limpar filtros
          </button>
          <button
            type="button"
            onClick={handleApply}
            className="px-6 py-2 bg-purple-600 text-white rounded-lg font-medium hover:bg-purple-700 transition-colors text-sm"
          >
            Aplicar filtros
          </button>
        </div>
      </div>
    </div>
  );
};
